const STORED_ORDERS_KEY = "storedSimulatorOrders";

export const OrderStates = {
  CREATED: "start",
  ARRIVED: "arriveNow",
  TIMEOUT: "timeout",
  STOPPED: "stop",
};

export const getStoredSimulations = () => {
  const storedOrdersString = localStorage.getItem(STORED_ORDERS_KEY);
  if (storedOrdersString) {
    return JSON.parse(storedOrdersString);
  }
  return [];
};

export const addToStoredSimulations = (
  project,
  zone,
  customerName,
  carMake,
  carPlate,
  orderId,
  startDistance,
  intervalTime,
  intervalDistance
) => {
  const newOrder = {
    project,
    zone,
    orderId,
    customerName,
    startDistance,
    intervalTime,
    intervalDistance,
    carMake,
    carPlate,
    status: OrderStates.CREATED,
    createdAt: new Date(),
    updatedAt: new Date(),
  };

  const storedOrders = getStoredSimulations();
  storedOrders.push(newOrder);
  localStorage.setItem(STORED_ORDERS_KEY, JSON.stringify(storedOrders));
};

export const updatedStoredOrder = (orderId, newStatus) => {
  const storedSimulations = getStoredSimulations();
  const targetOrder = storedSimulations.find(
    (simulation) => simulation.orderId === orderId
  );
  if (!targetOrder) {
    throw new Error("Target order not found. Update failed");
  }
  targetOrder.status = newStatus;
  localStorage.setItem(STORED_ORDERS_KEY, JSON.stringify(storedSimulations));
};

export const clearStoredSimulations = () => {
  localStorage.removeItem(STORED_ORDERS_KEY);
};
